import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { getDefaultDashboardDateRange } from '../../utils/requirementDateFilter';

function DashboardDateFilter({ onApply, onReset }) {
  const [fromDate, setFromDate] = useState(() => getDefaultDashboardDateRange().from);
  const [toDate, setToDate] = useState(() => getDefaultDashboardDateRange().to);

  useEffect(() => {
    const defaultRange = getDefaultDashboardDateRange();
    onApply?.(defaultRange);
  }, [onApply]);

  const handleApply = () => {
    onApply?.({ from: fromDate, to: toDate });
  };

  const handleReset = () => {
    const nextRange = getDefaultDashboardDateRange();
    setFromDate(nextRange.from);
    setToDate(nextRange.to);
    onReset?.(nextRange);
    onApply?.(nextRange);
  };

  return (
    <div className="hr-dashboard-date-filter">
      <span className="hr-dashboard-date-filter-label">Date range</span>
      <div className="hr-dashboard-date-filter-fields">
        <input
          type="date"
          className="hr-dashboard-date-input"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          aria-label="From date"
        />
        <span className="hr-dashboard-date-sep" aria-hidden>–</span>
        <input
          type="date"
          className="hr-dashboard-date-input"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          aria-label="To date"
        />
      </div>
      <div className="hr-dashboard-date-filter-actions">
        <Button variant="primary" className="hr-btn-primary hr-dashboard-date-btn" size="sm" onClick={handleApply}>
          Apply
        </Button>
        <Button variant="outline-secondary" className="hr-dashboard-date-btn" size="sm" onClick={handleReset}>
          Reset
        </Button>
      </div>
    </div>
  );
}

export default DashboardDateFilter;
